import { getPath } from 'routes/router-paths';
import {
  APP_MENU_CODE,
  APP_MODULE_CODE,
  type TMenuItem,
} from 'shared/components/AppMainNavigationSideBar/types';

const menuIcon = (
  <div className="block size-[0.8rem] !min-w-0 rounded-full border border-secondary" />
);

export const menuItems: TMenuItem[] = [
  /** =========================================================================
   * Module: Trang chủ (HOME) - Tĩnh
   * ========================================================================= */
  {
    key: APP_MODULE_CODE.HOME,
    label: 'Trang chủ',
    type: 'group',
    code: APP_MODULE_CODE.HOME,
    children: [
      {
        key: getPath('dashboardPage'),
        label: 'Báo cáo dashboard',
        code: APP_MENU_CODE.HOME,
        icon: menuIcon,
      },
      {
        key: getPath('reportPage'),
        label: 'Thông tin nội bộ',
        code: APP_MENU_CODE.REPORT,
        icon: menuIcon,
      },
    ],
  },

  /** =========================================================================
   * Module: Kế toán (ACCOUNTING)
   * ========================================================================= */
  {
    key: APP_MODULE_CODE.ACCOUNTING,
    label: 'Kế toán',
    type: 'group',
    code: APP_MODULE_CODE.ACCOUNTING,
    children: [
      {
        key: APP_MENU_CODE.ACCOUNTING_DEBTS,
        label: 'Công nợ',
        code: APP_MENU_CODE.ACCOUNTING_DEBTS,
        icon: menuIcon,
        popupClassName: 'app-nav-submenu-popup',
        children: [
          {
            key: getPath('accountingDebtDataProcessingPage'),
            label: 'Xử lý dữ liệu',
            code: APP_MENU_CODE.ACCOUNTING_DATA_PROCESSING,
            icon: menuIcon,
          },
          {
            key: getPath('accountingDebtPendingDataPage'),
            label: 'Dữ liệu treo',
            code: APP_MENU_CODE.ACCOUNTING_PENDING_DATA,
            icon: menuIcon,
          },
          {
            key: getPath('accountingDebtReportsPage'),
            label: 'Báo cáo',
            code: APP_MENU_CODE.ACCOUNTING_DEBT_REPORTS,
            icon: menuIcon,
          },
        ],
      },
      {
        key: APP_MENU_CODE.ACCOUNTING_TAX,
        label: 'Thuế',
        code: APP_MENU_CODE.ACCOUNTING_TAX,
        icon: menuIcon,
        popupClassName: 'app-nav-submenu-popup',
        children: [
          {
            key: getPath('accountingTaxInvoiceRequestPage'),
            label: 'Yêu cầu hoá đơn',
            code: APP_MENU_CODE.ACCOUNTING_INVOICE_REQUEST,
            icon: menuIcon,
          },
          {
            key: getPath('accountingTaxIssuedInvoicePage'),
            label: 'Hoá đơn xuất',
            code: APP_MENU_CODE.ACCOUNTING_ISSUED_INVOICE,
            icon: menuIcon,
          },
        ],
      },
      {
        key: APP_MENU_CODE.ACCOUNTING_DEBT_SUMMARY,
        label: 'Tổng hợp công nợ',
        code: APP_MENU_CODE.ACCOUNTING_DEBT_SUMMARY,
        icon: menuIcon,
        popupClassName: 'app-nav-submenu-popup',
        children: [
          {
            key: getPath('accountingCustomerDebtSummaryPage'),
            label: 'Tổng hợp công nợ khách hàng',
            code: APP_MENU_CODE.ACCOUNTING_CUSTOMER_DEBT_SUMMARY,
            icon: menuIcon,
          },
          {
            key: getPath('accountingSupplierDebtSummaryPage'),
            label: 'Tổng hợp công nợ nhà cung cấp',
            code: APP_MENU_CODE.ACCOUNTING_SUPPLIER_DEBT_SUMMARY,
            icon: menuIcon,
          },
        ],
      },
      {
        key: getPath('accountingManagementPage'),
        label: 'Quản trị module Kế toán',
        code: APP_MENU_CODE.ACCOUNTING_ADMIN,
        icon: menuIcon,
      },
    ],
  },

  /** =========================================================================
   * Module: Hành chính nhân sự (HR)
   * ========================================================================= */
  {
    key: APP_MODULE_CODE.HR,
    label: 'Hành chính - nhân sự',
    type: 'group',
    code: APP_MODULE_CODE.HR,
    children: [
      {
        key: getPath('hrPersonnelPage'),
        label: 'Quản lý nhân sự',
        code: APP_MENU_CODE.HR_PERSONNEL,
        icon: menuIcon,
      },
      {
        key: getPath('hrTimekeepingPage'),
        label: 'Quản lý chấm công',
        code: APP_MENU_CODE.HR_TIMEKEEPING,
        icon: menuIcon,
      },
      {
        key: getPath('hrAssetPage'),
        label: 'Quản lý tài sản',
        code: APP_MENU_CODE.HR_ASSET,
        icon: menuIcon,
      },
      {
        key: getPath('hrDepartmentPage'),
        label: 'Phòng ban',
        code: APP_MENU_CODE.HR_DEPARTMENT,
        icon: menuIcon,
      },
    ],
  },

  /** =========================================================================
   * Module: Văn bản (DOCUMENT)
   * ========================================================================= */
  // {
  //   key: APP_MODULE_CODE.DOCUMENT,
  //   label: 'Văn bản',
  //   code: APP_MODULE_CODE.DOCUMENT,
  //   type: 'group',
  //   children: [
  //     {
  //       key: getPath(
  //         'internalDocumentsListPage',
  //         INTERNAL_DOCUMENT_TYPE.INCOMING
  //       ),
  //       label: 'Văn bản nội bộ',
  //       code: APP_MENU_CODE.INTERNAL_DOCUMENT,
  //       icon: menuIcon,
  //     },
  //     {
  //       key: uuid(),
  //       label: 'Quản trị văn bản',
  //       code: APP_MENU_CODE.DOCUMENT_ADMIN,
  //       icon: menuIcon,
  //     },
  //   ],
  // },

  /** =========================================================================
   * Module: e-Office (E_OFFICE)
   * ========================================================================= */
  // {
  //   key: APP_MODULE_CODE.E_OFFICE,
  //   label: 'e-Office',
  //   type: 'group',
  //   code: APP_MODULE_CODE.E_OFFICE,
  //   children: [
  //     {
  //       key: getPath('workListPage', WORK_TYPE.ALL),
  //       label: 'Công việc',
  //       code: APP_MENU_CODE.TASK,
  //       icon: menuIcon,
  //     },
  //     {
  //       key: getPath('proposalListPage'),
  //       label: 'Đơn hành chính',
  //       code: APP_MENU_CODE.ADMIN_FORM,
  //       icon: menuIcon,
  //     },
  //     {
  //       key: getPath(
  //         'eOfficeManagementPage',
  //         E_OFFICE_MANAGEMENT_TYPE.APPROVAL_TEMPLATE
  //       ),
  //       label: 'Quản trị e-Office',
  //       code: APP_MENU_CODE.E_OFFICE_ADMIN,
  //       icon: menuIcon,
  //     },
  //   ],
  // },

  /** =========================================================================
   * Module: Nhiệm vụ (TASK)
   * ========================================================================= */
  // {
  //   key: APP_MODULE_CODE.TASK_MODULE,
  //   label: 'Nhiệm vụ',
  //   type: 'group',
  //   code: APP_MODULE_CODE.TASK_MODULE,
  //   children: [
  //     {
  //       key: getPath('taskListPage'),
  //       label: 'Danh mục nhiệm vụ',
  //       code: APP_MENU_CODE.TASK_LIST,
  //       icon: menuIcon,
  //     },
  //     {
  //       key: uuid(),
  //       label: 'Báo cáo nhiệm vụ',
  //       code: APP_MENU_CODE.TASK_REPORT,
  //       icon: menuIcon,
  //     },
  //     {
  //       key: getPath('taskManagementPermission'),
  //       label: 'Quản trị nhiệm vụ',
  //       code: APP_MENU_CODE.TASK_ADMIN,
  //       icon: menuIcon,
  //     },
  //   ],
  // },

  /** =========================================================================
   * Module: Tiện ích (UTILITY)
   * ========================================================================= */
  // {
  //   key: APP_MODULE_CODE.UTILITY,
  //   label: 'Tiện ích',
  //   type: 'group',
  //   code: APP_MODULE_CODE.UTILITY,
  //   children: [
  //     {
  //       key: getPath('workSchedulePage'),
  //       label: 'Lịch cơ quan',
  //       code: APP_MENU_CODE.CALENDAR,
  //       icon: menuIcon,
  //     },
  //     {
  //       key: getPath('digitalSignaturePage'),
  //       label: 'Ký số điện tử',
  //       code: APP_MENU_CODE.DIGITAL_SIGN,
  //       icon: menuIcon,
  //     },
  //     {
  //       key: getPath('contactPage'),
  //       label: 'Danh bạ công ty',
  //       code: APP_MENU_CODE.DIRECTORY,
  //       icon: menuIcon,
  //     },
  //     {
  //       key: getPath('myDocumentPage'),
  //       label: 'Tài liệu',
  //       code: APP_MENU_CODE.DOCUMENT_MGMT,
  //       icon: menuIcon,
  //     },
  //     {
  //       key: getPath('newsListPage'),
  //       label: 'Thông báo chung',
  //       code: APP_MENU_CODE.NOTICE,
  //       icon: menuIcon,
  //     },
  //     {
  //       key: getPath(
  //         'utilityManagementPage',
  //         UTILITY_MANAGEMENT_TAB.WORK_SCHEDULE
  //       ),
  //       label: 'Quản trị tiện ích',
  //       code: APP_MENU_CODE.UTILITY_ADMIN,
  //       icon: menuIcon,
  //     },
  //   ],
  // },

  /** =========================================================================
   * Module: Quản trị hệ thống (SYSTEM)
   * ========================================================================= */
  // {
  //   key: APP_MODULE_CODE.SYSTEM,
  //   label: 'Quản trị hệ thống',
  //   type: 'group',
  //   code: APP_MODULE_CODE.SYSTEM,
  //   children: [
  //     {
  //       key: getPath('managementPermission'),
  //       label: 'Phân quyền',
  //       code: APP_MENU_CODE.SYSTEM_PERMISSION,
  //       icon: menuIcon,
  //     },
  //     {
  //       key: getPath('accountManagementPage'),
  //       label: 'Tài khoản',
  //       code: APP_MENU_CODE.SYSTEM_ACCOUNT,
  //       icon: menuIcon,
  //     },
  //     {
  //       key: getPath('systemCategoryPage', SYSTEM_CATEGORY_TAB.DEPARTMENT),
  //       label: 'Danh mục',
  //       code: APP_MENU_CODE.CATEGORY,
  //       icon: menuIcon,
  //     },
  //     {
  //       key: getPath('signAccountManagementPage'),
  //       label: 'Tài khoản ký số',
  //       code: APP_MENU_CODE.SIGN_ACCOUNTS,
  //       icon: menuIcon,
  //     },
  //   ],
  // },
];
